module.exports = __webpack_public_path__ + "img/logo.43b29598.png";